export function asCurrencyIconCode(name) {
    return name.toLowerCase();
}
